const industryDetails = {
    realEstate: {
        intoPageHeading:"India's Simplest Real Estate CRM Software",
        intoPageSubHeading:"Track your agents, boost calling efficiency, automate repetitive tasks, and take your business to the next level with India's No. 1 Real Estate CRM.",
        intoPgaeIcons:[
            {
                iconName : "",
                iconExplantion:"Auto-lead Capture",
            },
            {
                iconName : "",
                iconExplantion:"Call Recording and Tracking",
            },
            {
                iconName : "",
                iconExplantion:"Auto-dialer",
            },
            {
                iconName : "",
                iconExplantion:"Auto-lead Capture",
            },
            {
                iconName : "",
                iconExplantion:"Auto-lead Capture",
            },
            {
                iconName : "",
                iconExplantion:"Auto-lead Capture",
            },
        ],
        miniCard:[
            {
                heading: "Stay on Top of Follow-ups",
                content: "Don't lose leads due to ineffective communication; always follow up on time",
                icon: "iconName"

            },
            {
                heading: "Boost Calling Efficiency",
                content: "Make more accurate calls with features like auto-dialer and click-to-call from web and convert more deals than ever before",
                icon: "iconName"

            },
            {
                heading: "Effortlessly Manage All Leads",
                content: "Securely capture and store lead data in one central hub by integrating with third-party platforms for easy access and management.",
                icon: "iconName"

            },
            {
                heading: "Track and Manage Team Remotely",
                content: "Track your team's location from anywhere with TeleCRM's check-in option that captures site visits.",
                icon: "iconName",
            },
            {
                heading: "Automate Routine Tasks",
                content: "Automatically capture and distribute leads, send instant welcome messages to leads, update deal status, and more.",
                icon: "iconName"

            },
            {
                heading: "Nurture Multiple Leads at Once",
                content: "Send personalized bulk WhatsApp marketing messages to leads about property listings, hot deals, etc based on their stage in the sales process.",
                icon: "iconName"

            }
        ]
    },
}

export default industryDetails;